export const BREAKPOINT_MOBILE = 480;
export const BREAKPOINT_MOBLET = 600;
export const BREAKPOINT_TABLET = 768;
export const BREAKPOINT_TABTOP = 1024;
export const BREAKPOINT_DESKTOP = 1200;
